import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/store/auth";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session-exchange",
          { session_id },
          { withCredentials: true }
        );
        setUser({
          user_id: data.user_id, email: data.email, name: data.name,
          role: data.role, picture: data.picture,
        });
        // Clear the hash and redirect
        window.history.replaceState(null, "", "/");
        nav(data.role === "owner" ? "/admin" : "/profile", { replace: true });
      } catch (e) {
        console.error("OAuth exchange failed:", e);
        nav("/login?error=oauth", { replace: true });
      }
    })();
  }, [location, nav, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback-page">
      <div className="text-white/60 text-sm">Signing you in…</div>
    </div>
  );
}
